import React, { useState } from "react"
import LeftSidebarMenu from "@/components/Layout/LeftSidebarMenu"
import TopNavbar from "@/components/Layout/TopNavbar/index"
import Footer from "@/components/Layout/Footer"
import ControlPanel from "@/components/Layout/ControlPanel"
import PermissionGate from "@/guards/PermissionGate"

import "swiper/css"
import "swiper/css/bundle"
import "remixicon/fonts/remixicon.css"
import "@/../styles/front-pages.css"
import "@/../styles/control-panel.css"
import "@/../styles/left-sidebar-menu.css"
import "@/../styles/top-navbar.css"
import "@/../styles/globals.css"
// globals dark Mode CSS
import "@/../styles/dark.css"
// globals RTL Mode CSS
import "@/../styles/rtl.css"

const MainLayout: React.FC = () => {
  const [active, setActive] = useState<boolean>(false)

  const toggleActive = () => {
    setActive(!active)
  }

  return (
    <>
      <div
        className={`main-wrapper-content min-h-screen flex flex-col ${active ? "active" : ""}`}
      >
        <>
          <TopNavbar toggleActive={toggleActive} />

          <LeftSidebarMenu toggleActive={toggleActive} />
        </>

        <div className="main-content flex flex-1 flex-col">
          <div className="flex-1">
            <PermissionGate />
          </div>

          <Footer />
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "15px",
          right: "15px",
          zIndex: "-5",
          opacity: 0,
          visibility: "hidden",
        }}
      >
        <ControlPanel />
      </div>
    </>
  )
}

export default MainLayout
